import React from 'react'
import PropTypes from 'prop-types'

const PressIcon = props => {
  return props.active ? (
    <svg
      aria-hidden="true"
      className="navigation-icon active"
      width="73"
      height="71"
      viewBox="0 0 81 79"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Press</title>
      <defs>
        <filter
          x="-77.8%"
          y="-76.1%"
          width="255.6%"
          height="252.2%"
          filterUnits="objectBoundingBox"
          id="press_filter"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="9" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <path id="press_path" d="M0 0h45v46H0z" />
      </defs>
      <g filter="url(#press_filter)" transform="translate(18 17)" fill="none" fillRule="evenodd">
        <mask id="press_mask" fill="#fff">
          <use href="#press_path" />
        </mask>
        <path
          d="M21.775 11.694v29.374c-2.359-1.607-4.437-1.607-7.295-1.607H2.856V9.251H14.48c3.2 0 4.524 0 6.623 1.852l.672.591zm2.854-1.147l-.019-.111c-.006-.041-.163-1.018.026-2.264.184-1.21.625-2.23 1.308-3.032 1.085-1.278 2.818-2.031 5.153-2.242v30.515c-2.7.202-4.875 1.002-6.466 2.38V11.662l-.002-1.115zM25.944 38.5c1.3-1.528 3.514-2.302 6.581-2.302h1.428V9.252h8.192V39.46H31.926c-2.82 0-4.874 0-7.188 1.534.224-.978.63-1.817 1.206-2.494zm8.01-32.086V0h-1.429c-3.963 0-6.919 1.122-8.785 3.334-1.074 1.274-1.735 2.85-1.965 4.687-2.359-1.606-4.436-1.606-7.295-1.606H0v35.883h14.48c3.2 0 4.524 0 6.623 1.85l2.1 1.852 2.1-1.852c2.1-1.85 3.424-1.85 6.623-1.85H45V6.415H33.953z"
          fill="#FFF"
          mask="url(#press_mask)"
        />
      </g>
    </svg>
  ) : (
    <svg
      aria-hidden="true"
      className="navigation-icon"
      width="73"
      height="71"
      viewBox="0 0 81 79"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Press</title>
      <defs>
        <path id="press_path" d="M0 0h45v46H0z" />
      </defs>
      <g transform="translate(18 17)" fill="none" fillRule="evenodd">
        <mask id="press_mask" fill="#fff">
          <use href="#press_path" />
        </mask>
        <path
          d="M21.775 11.694v29.374c-2.359-1.607-4.437-1.607-7.295-1.607H2.856V9.251H14.48c3.2 0 4.524 0 6.623 1.852l.672.591zm2.854-1.147l-.019-.111c-.006-.041-.163-1.018.026-2.264.184-1.21.625-2.23 1.308-3.032 1.085-1.278 2.818-2.031 5.153-2.242v30.515c-2.7.202-4.875 1.002-6.466 2.38V11.662l-.002-1.115zM25.944 38.5c1.3-1.528 3.514-2.302 6.581-2.302h1.428V9.252h8.192V39.46H31.926c-2.82 0-4.874 0-7.188 1.534.224-.978.63-1.817 1.206-2.494zm8.01-32.086V0h-1.429c-3.963 0-6.919 1.122-8.785 3.334-1.074 1.274-1.735 2.85-1.965 4.687-2.359-1.606-4.436-1.606-7.295-1.606H0v35.883h14.48c3.2 0 4.524 0 6.623 1.85l2.1 1.852 2.1-1.852c2.1-1.85 3.424-1.85 6.623-1.85H45V6.415H33.953z"
          fill="#FFF"
          mask="url(#press_mask)"
        />
      </g>
    </svg>
  )
}

Window.propTypes = {
  active: PropTypes.string
}

export default PressIcon
